import React, { useEffect } from "react";
import Breadcrumb from "../../../../components/Breadcrum";
// import InfoContainer from "../../../../components/InfoContainer";
import "./FMCG.css";
export default function FMCG() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Cosmetics"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      ></Breadcrumb>
      {/* <div className="fmcg">
        <InfoContainer
          title="Global FMCG Solutions for Everyday Needs"
          paragraph1="As a leading supplier of Fast-Moving Consumer Goods (FMCG), we provide a wide range of everyday products that consumers rely on. From food and beverages to personal care items, cleaning products, and over-the-counter medicines, our FMCG offerings cater to markets worldwide."
          paragraph2="We understand the fast-paced nature of the FMCG industry, which is why we focus on delivering quality products that meet consumer demand. Our global distribution network ensures that products are delivered quickly and efficiently, and our range includes both global brands and private label options."
          paragraph3="We are committed to innovation, sustainability, and maintaining a high standard of quality across all FMCG products."
        />
      </div> */}
    </>
  );
}
